<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
      font-weight: 400;
      color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;Article Availability Report</h5>
  </div>
  <div class="container" id="mainContent">
    <div class="modal-body">
      <div class="row">
        <div class="col-sm-5">
          <div class="row">
            <label class="col-sm-4 col-form-label">Branch<span class="text-danger">*</span></label>
            <div class="col-sm-6">
              <mat-form-field appearance="legacy" style="width: 100%">
                <mat-select multiple [(ngModel)]="selectedBranch" #designateBranch="ngModel">
                  <mat-option (click)="selectAllBranch(designateBranch, branchList)" [value]="0">Select All
                  </mat-option>
                  <mat-option (click)="getPartnerByBranch()" #item *ngFor="let branch of branchList" [value]="branch">
                    {{ branch.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="row">
            <label class="col-sm-4 col-form-label">Reporting Partner<span class="text-danger">*</span></label>
            <div class="col-sm-6">
              <mat-form-field appearance="legacy" style="width: 100%">
                <mat-select multiple [(ngModel)]="selectedPartner" #designatePartner="ngModel">
                  <mat-option (click)="selectAllPartner(designatePartner, partnerList)" [value]="0">Select All
                  </mat-option>
                  <mat-option #item *ngFor="let partner of partnerList" [value]="partner">
                    {{ partner.firstName }} {{partner.middleName}} {{ partner.lastName }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-1">
        <div class="col-sm-2">
          <button type="button" class="btn btn-sm btn-block btn-outline-theme" (click)="onViewReport()">
            View Report
          </button>
        </div>
        <div class="col-sm-2" *ngIf="showExportToExcelButton">
          <button (click)="exportToExcelForArticleAvailabilityReport()" class="btn btn-sm btn-block btn-outline-theme">
            <i class="fa fa-file-excel-o mr-2"></i>Export to Excel
          </button>
        </div>

        <div class="col-sm-2" *ngIf="showExportToExcelButton">
          <button (click)="exportToPDFClick()" class="btn btn-sm btn-block btn-outline-theme">
            <i class="fa fa-file-pdf-o mr-2"></i>Export As PDF
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="container" id="mainContent">
    <div class="pt-2" *ngIf="articleAvailabilityReport != null">
      <div class="row mt-2 justify-content-center text-center">
        <span class="bg-theme-title">P G BHAGWAT LLP, Chartered Accountants
        </span>
      </div>
      <div class="row justify-content-center text-center ">
        <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
      </div>
      <div class="row mt-2 justify-content-center text-center">
        <span class="bg-theme-title">Article Availability</span>
      </div>
      <div class="row mt-2" *ngFor="let data of articleAvailabilityReport">
        <div class="col-sm-8">
          <label class="col-form-label"><b>Reporting Partner : </b>
            {{data.firstName}} {{data.middleName}} {{data.lastName}}</label>
        </div>
        <div class="col-sm-4">
          <label class="col-form-label"><b>Branch : </b>
            {{data.branch}}</label>
        </div>
        <div class="col-md-12">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>Article Name</th>
                <th>Leave From Date</th>
                <th>Leave To Date</th>
                <th>Articleship End Date</th>
                <th>Reporting Manager</th>
                <th>Available Articles</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let detail of data.details">
                <td>{{detail.firstName}} {{detail.middleName}} {{detail.lastName}}</td>
                <td>{{(detail.leaveDays<=6)?'Available':(detail.leaveDays==null)?'Available':detail.fromDate |
                    date:'dd-MM-yyyy'}}</td>
                <td>{{(detail.leaveDays<=6)?'Available':(detail.leaveDays==null)?'Available':detail.toDate |
                    date:'dd-MM-yyyy'}}</td>
                <td>{{detail.articleshipEndDate | date:'dd-MM-yyyy'}}</td>
                <td>{{detail.mgrFirstName}} {{detail.mgrMiddleName}} {{detail.mgrLastName}}</td>
                <td>{{detail.availableArticles}}</td>
              </tr>
              <tr style="background-color: #e1f4f7">
                <td>Total Available Articles</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>{{getTotalAvailableArticle(data)}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>